/**
 * Merchant information adapter for frontend
 * @param {*} data of merchant
 *
 * This function replaces created_at with started_at, only if it exists.
 */
export const merchantAdapter = (data) => ({
  ...data,
  created_at: data.started_at || data.created_at,
});
